import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 style={{ textAlign: "center" }}>404, sorry page not found</h1>
        </div>
    );
};

export default NotFound;